import enLabels from "./compiled/en/labels.json";
import enErrors from "./compiled/en/errors.json";
import enTableHeaders from "./compiled/en/tableheaders.json";

import frLabels from "./compiled/fr/labels.json";
import frErrors from "./compiled/fr/errors.json";
import frTableHeaders from "./compiled/fr/tableheaders.json";

// Utility to flatten nested JSON into flat key-value pairs with dot notation keys
const flattenMessages = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nestedMessages: Record<string, any>,
  prefix = "",
): Record<string, string> => {
  return Object.keys(nestedMessages).reduce(
    (messages, key) => {
      const value = nestedMessages[key];
      const prefixedKey = prefix ? `${prefix}.${key}` : key;

      if (typeof value === "string") {
        messages[prefixedKey] = value;
      } else {
        Object.assign(messages, flattenMessages(value, prefixedKey));
      }
      return messages;
    },
    {} as Record<string, string>,
  );
};

const mergeMessages = (
  ...sources: Record<string, string>[]
): Record<string, string> => {
  return Object.assign({}, ...sources);
};

const loadMessages = (locale: string): Record<string, string> => {
  switch (locale) {
    case "fr-CA":
      return mergeMessages(
        flattenMessages(frLabels),
        flattenMessages(frErrors),
        flattenMessages(frTableHeaders),
      );
    case "en-US":
    default:
      return mergeMessages(
        flattenMessages(enLabels),
        flattenMessages(enErrors),
        flattenMessages(enTableHeaders),
      );
  }
};

export default loadMessages;
